

// // // import { useEffect, useState } from "react";
// // // import { ShoppingCart, Package, Sparkles } from "lucide-react";
// // // import DashboardLayout from "../layouts/DashboardLayout";
// // // import { AuthAPI } from "../api/AuthAPI";

// // // export default function DashboardHome() {
// // //   const [loading, setLoading] = useState(true);

// // //   const [stats, setStats] = useState({
// // //     cart: "00",
// // //     wishlist: "00",
// // //     orders: "00",
// // //   });

// // //   useEffect(() => {
// // //     async function loadDashboard() {
// // //       try {
// // //         setLoading(true);

// // //         const res = await AuthAPI.dashboard();

// // //         const data = res?.data?.data || {};

// // //         setStats({
// // //           cart: pad(data?.cart_count ?? 0),
// // //           wishlist: pad(data?.wishlist_count ?? 0),
// // //           orders: pad(data?.orders_count ?? 0),
// // //         });
// // //       } catch (err) {
// // //         console.error("Dashboard API failed", err);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     }

// // //     loadDashboard();
// // //   }, []);

// // //   return (
// // //     <DashboardLayout>
// // //       <div className="space-y-8">
// // //         {/* Hero Banner */}
// // //         <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-yellow-500 via-orange-500 to-amber-600 p-8 md:p-10 text-white shadow-xl">
// // //           <div className="absolute inset-0 opacity-10">
// // //             <div className="absolute -right-20 -top-20 w-72 h-72 bg-white rounded-full" />
// // //             <div className="absolute -left-20 -bottom-20 w-60 h-60 bg-white rounded-full" />
// // //           </div>

// // //           <div className="relative z-10 flex items-center justify-between">
// // //             <div>
// // //               <h1 className="text-3xl md:text-4xl font-bold">
// // //                 Welcome Back 👋
// // //               </h1>

// // //               <p className="mt-2 text-yellow-100 text-sm md:text-base">
// // //                 Here's an overview of your shopping activity.
// // //               </p>
// // //             </div>

// // //             <div className="hidden md:flex items-center justify-center w-20 h-20 rounded-3xl bg-white/20 backdrop-blur-md">
// // //               <Sparkles size={38} />
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* Stats */}
// // //         {loading ? (
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
// // //             {[1, 2].map((i) => (
// // //               <div
// // //                 key={i}
// // //                 className="h-44 rounded-3xl bg-gray-100 animate-pulse"
// // //               />
// // //             ))}
// // //           </div>
// // //         ) : (
// // //           <>
// // //             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
// // //               <StatCard
// // //                 title="Products in Cart"
// // //                 value={stats.cart}
// // //                 icon={<ShoppingCart size={30} />}
// // //                 gradient="from-yellow-500 to-orange-500"
// // //               />

// // //               <StatCard
// // //                 title="Total Orders"
// // //                 value={stats.orders}
// // //                 icon={<Package size={30} />}
// // //                 gradient="from-orange-500 to-red-500"
// // //               />
// // //             </div>

// // //             {/* Quick Overview */}
// // //             <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6">
// // //               <h3 className="text-lg font-semibold text-gray-800 mb-6">
// // //                 Account Summary
// // //               </h3>

// // //               <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
// // //                 <MiniCard label="Cart Items" value={stats.cart} />
// // //                 <MiniCard label="Orders" value={stats.orders} />
// // //                 <MiniCard label="Status" value="Active" />
// // //                 <MiniCard label="Member" value="Premium" />
// // //               </div>
// // //             </div>
// // //           </>
// // //         )}
// // //       </div>
// // //     </DashboardLayout>
// // //   );
// // // }

// // // /* ================= PREMIUM STAT CARD ================= */

// // // const StatCard = ({ title, value, icon, gradient }) => (
// // //   <div className="group relative overflow-hidden rounded-3xl bg-white border border-gray-100 shadow-sm hover:shadow-2xl transition-all duration-500 p-7">
// // //     <div
// // //       className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 transition`}
// // //     />

// // //     <div className="flex items-center justify-between">
// // //       <div>
// // //         <p className="text-gray-500 text-sm font-medium">{title}</p>

// // //         <h2 className="mt-3 text-5xl font-bold text-gray-900">{value}</h2>
// // //       </div>

// // //       <div
// // //         className={`w-20 h-20 rounded-3xl bg-gradient-to-br ${gradient} text-white flex items-center justify-center shadow-lg group-hover:scale-110 transition duration-300`}
// // //       >
// // //         {icon}
// // //       </div>
// // //     </div>

// // //     <div className="mt-6 h-1 w-full bg-gray-100 rounded-full overflow-hidden">
// // //       <div className={`h-full bg-gradient-to-r ${gradient} w-3/4`} />
// // //     </div>
// // //   </div>
// // // );

// // // /* ================= MINI CARD ================= */

// // // const MiniCard = ({ label, value }) => (
// // //   <div className="rounded-2xl bg-gray-50 border border-gray-100 p-5 hover:bg-white hover:shadow-md transition">
// // //     <p className="text-sm text-gray-500">{label}</p>

// // //     <h4 className="mt-2 text-2xl font-bold text-gray-900">{value}</h4>
// // //   </div>
// // // );

// // // /* ================= HELPERS ================= */

// // // function pad(n) {
// // //   const s = String(n);
// // //   return s.length === 1 ? `0${s}` : s;
// // // }











// // import { useEffect, useState } from "react";
// // import { ShoppingCart, Package, Sparkles } from "lucide-react";
// // import DashboardLayout from "../layouts/DashboardLayout";
// // import { AuthAPI } from "../api/AuthAPI";

// // export default function DashboardHome() {
// //   const [loading, setLoading] = useState(true);

// //   const [stats, setStats] = useState({
// //     cart: "00",
// //     wishlist: "00",
// //     orders: "00",
// //   });

// //   useEffect(() => {
// //     async function loadDashboard() {
// //       try {
// //         setLoading(true);

// //         const res = await AuthAPI.dashboard();

// //         const data = res?.data?.data || {};

// //         setStats({
// //           cart: pad(data?.cart_count ?? 0),
// //           wishlist: pad(data?.wishlist_count ?? 0),
// //           orders: pad(data?.orders_count ?? 0),
// //         });
// //       } catch (err) {
// //         console.error("Dashboard API failed", err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     }

// //     loadDashboard();
// //   }, []);

// //   return (
// //     <DashboardLayout>
// //       <div className="space-y-8">
// //         {/* Hero Banner */}
// //         <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-pink-500 via-fuchsia-500 to-blue-600 p-8 md:p-10 text-white shadow-xl">
// //           <div className="absolute inset-0 opacity-10">
// //             <div className="absolute -right-20 -top-20 w-72 h-72 bg-white rounded-full" />
// //             <div className="absolute -left-20 -bottom-20 w-60 h-60 bg-white rounded-full" />
// //           </div>

// //           <div className="relative z-10 flex items-center justify-between">
// //             <div>
// //               <h1 className="text-3xl md:text-4xl font-bold">
// //                 Welcome Back 👋
// //               </h1>

// //               <p className="mt-2 text-pink-100 text-sm md:text-base">
// //                 Here's an overview of your shopping activity.
// //               </p>
// //             </div>

// //             <div className="hidden md:flex items-center justify-center w-20 h-20 rounded-3xl bg-white/20 backdrop-blur-md">
// //               <Sparkles size={38} />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Stats */}
// //         {loading ? (
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
// //             {[1, 2].map((i) => (
// //               <div
// //                 key={i}
// //                 className="h-44 rounded-3xl bg-gray-100 animate-pulse"
// //               />
// //             ))}
// //           </div>
// //         ) : (
// //           <>
// //             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
// //               <StatCard
// //                 title="Products in Cart"
// //                 value={stats.cart}
// //                 icon={<ShoppingCart size={30} />}
// //                 gradient="from-pink-500 to-fuchsia-500"
// //               />

// //               <StatCard
// //                 title="Total Orders"
// //                 value={stats.orders}
// //                 icon={<Package size={30} />}
// //                 gradient="from-blue-500 to-cyan-500"
// //               />
// //             </div>

// //             {/* Quick Overview */}
// //             <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6">
// //               <h3 className="text-lg font-semibold text-gray-800 mb-6">
// //                 Account Summary
// //               </h3>

// //               <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
// //                 <MiniCard label="Cart Items" value={stats.cart} />
// //                 <MiniCard label="Orders" value={stats.orders} />
// //                 <MiniCard label="Status" value="Active" />
// //                 <MiniCard label="Member" value="Premium" />
// //               </div>
// //             </div>
// //           </>
// //         )}
// //       </div>
// //     </DashboardLayout>
// //   );
// // }

// // /* ================= PREMIUM STAT CARD ================= */

// // const StatCard = ({ title, value, icon, gradient }) => (
// //   <div className="group relative overflow-hidden rounded-3xl bg-white border border-gray-100 shadow-sm hover:shadow-2xl transition-all duration-500 p-7">
// //     <div
// //       className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 transition`}
// //     />

// //     <div className="flex items-center justify-between">
// //       <div>
// //         <p className="text-gray-500 text-sm font-medium">{title}</p>

// //         <h2 className="mt-3 text-5xl font-bold text-gray-900">{value}</h2>
// //       </div>

// //       <div
// //         className={`w-20 h-20 rounded-3xl bg-gradient-to-br ${gradient} text-white flex items-center justify-center shadow-lg group-hover:scale-110 transition duration-300`}
// //       >
// //         {icon}
// //       </div>
// //     </div>

// //     <div className="mt-6 h-1 w-full bg-gray-100 rounded-full overflow-hidden">
// //       <div className={`h-full bg-gradient-to-r ${gradient} w-3/4`} />
// //     </div>
// //   </div>
// // );

// // /* ================= MINI CARD ================= */

// // const MiniCard = ({ label, value }) => (
// //   <div className="rounded-2xl bg-gray-50 border border-gray-100 p-5 hover:bg-white hover:shadow-md transition">
// //     <p className="text-sm text-gray-500">{label}</p>

// //     <h4 className="mt-2 text-2xl font-bold text-gray-900">{value}</h4>
// //   </div>
// // );

// // /* ================= HELPERS ================= */

// // function pad(n) {
// //   const s = String(n);
// //   return s.length === 1 ? `0${s}` : s;
// // }

















// import { useEffect, useState } from "react";
// import { Package, Truck, CheckCircle, ShoppingCart } from "lucide-react";
// import { Link } from "react-router-dom";
// import DashboardLayout from "../layouts/DashboardLayout";
// import { AuthAPI } from "../api/AuthAPI";

// export default function DashboardHome() {
//   const [loading, setLoading] = useState(true);

//   const [stats, setStats] = useState({
//     total_orders: 0,
//     pending_orders: 0,
//     delivered_orders: 0,
//     active_cart: 0,
//   });

//   const [recentOrders, setRecentOrders] = useState([]);

//   useEffect(() => {
//     loadDashboard();
//   }, []);

//   async function loadDashboard() {
//     try {
//       setLoading(true);

//       const res = await AuthAPI.dashboard();
//       const data = res?.data?.data || {};

//       setStats({
//         total_orders: data?.stats?.total_orders ?? 0,
//         pending_orders: data?.stats?.pending_orders ?? 0,
//         delivered_orders: data?.stats?.delivered_orders ?? 0,
//         active_cart: data?.stats?.active_cart ?? 0,
//       });

//       setRecentOrders(data?.recent_orders || []);
//     } catch (err) {
//       console.error("Dashboard API failed", err);
//     } finally {
//       setLoading(false);
//     }
//   }

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });

//   const statusStyle = (status) => {
//     const s = status?.toLowerCase();
//     if (s === "delivered") return { bg: "#DCFCE7", color: "#15803D" };
//     if (s === "cancelled") return { bg: "#FEE2E2", color: "#DC2626" };
//     if (s === "shipped") return { bg: "#E3F2FD", color: "#1565C0" };
//     return { bg: "#FCE4EC", color: "#C2185B" };
//   };

//   const statCards = [
//     {
//       label: "Total Orders",
//       value: stats.total_orders,
//       icon: <Package size={18} />,
//       bg: "#FCE4EC",
//       color: "#C2185B",
//     },
//     {
//       label: "In Transit",
//       value: stats.pending_orders,
//       icon: <Truck size={18} />,
//       bg: "#E3F2FD",
//       color: "#1565C0",
//     },
//     {
//       label: "Delivered",
//       value: stats.delivered_orders,
//       icon: <CheckCircle size={18} />,
//       bg: "#E8F5E9",
//       color: "#2E7D32",
//     },
//     {
//       label: "In Cart",
//       value: stats.active_cart,
//       icon: <ShoppingCart size={18} />,
//       bg: "#FCE4EC",
//       color: "#C2185B",
//     },
//   ];

//   return (
//     <DashboardLayout>
//       <div className="space-y-5 mt-12 md:mt-0">
//         {/* STATS */}
//         {loading ? (
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {[1, 2, 3, 4].map((i) => (
//               <div key={i} className="h-28 rounded-2xl bg-gray-100 animate-pulse" />
//             ))}
//           </div>
//         ) : (
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {statCards.map((item, i) => (
//               <div
//                 key={i}
//                 className="bg-white rounded-2xl border border-gray-100 shadow-sm px-4 py-5 flex flex-col items-center text-center"
//               >
//                 <div
//                   className="w-9 h-9 rounded-lg flex items-center justify-center mb-3"
//                   style={{ background: item.bg, color: item.color }}
//                 >
//                   {item.icon}
//                 </div>

//                 <h3 className="text-2xl font-bold text-gray-900">{item.value}</h3>
//                 <p className="text-xs text-gray-500 mt-1">{item.label}</p>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* RECENT ORDERS */}
//         <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
//           <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
//             <h4 className="font-semibold text-gray-800">Recent Orders</h4>

//             <Link
//               to="/dashboard/purchase-history"
//               className="text-sm font-medium text-pink-600 hover:underline flex items-center gap-1"
//             >
//               View All <span aria-hidden>→</span>
//             </Link>
//           </div>

//           {loading ? (
//             <div className="p-5 space-y-3">
//               {[1, 2].map((i) => (
//                 <div key={i} className="h-16 rounded-xl bg-gray-100 animate-pulse" />
//               ))}
//             </div>
//           ) : recentOrders.length === 0 ? (
//             <div className="px-5 py-8 text-sm text-gray-500">No orders found</div>
//           ) : (
//             <div className="divide-y divide-gray-100">
//               {recentOrders.map((order) => {
//                 const status = statusStyle(order.order_status);
//                 const itemCount = order.items?.length || 0;
//                 const firstImage = order.items?.[0]?.image;

//                 return (
//                   <div
//                     key={order.id}
//                     className="flex items-center justify-between px-5 py-4 gap-4"
//                   >
//                     <div className="flex items-center gap-3 min-w-0">
//                       <img
//                         src={firstImage || "/placeholder.png"}
//                         alt=""
//                         className="w-12 h-12 rounded-lg object-cover border border-gray-100 flex-shrink-0"
//                       />

//                       <div className="min-w-0">
//                         <p className="font-semibold text-sm text-gray-900 truncate">
//                           #{order.order_number}
//                         </p>
//                         <p className="text-xs text-gray-500">
//                           {formatDate(order.createdAt)} · {itemCount} item
//                           {itemCount !== 1 ? "s" : ""}
//                         </p>
//                       </div>
//                     </div>

//                     <div className="text-right flex-shrink-0">
//                       <p className="font-bold text-sm text-gray-900">
//                         ₹{Number(order.grand_total).toLocaleString("en-IN")}
//                       </p>

//                       <span
//                         className="inline-block mt-1 text-[11px] font-semibold px-2.5 py-1 rounded-full capitalize"
//                         style={{ background: status.bg, color: status.color }}
//                       >
//                         {order.order_status}
//                       </span>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>
//     </DashboardLayout>
//   );
// }



















import { useEffect, useState } from "react";
import { Package, Truck, CheckCircle, ShoppingCart } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import { AuthAPI } from "../api/AuthAPI";

export default function DashboardHome() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    total_orders: 0,
    pending_orders: 0,
    delivered_orders: 0,
    active_cart: 0,
  });

  const [recentOrders, setRecentOrders] = useState([]);

  useEffect(() => {
    loadDashboard();
  }, []);

  async function loadDashboard() {
    try {
      setLoading(true);

      const res = await AuthAPI.dashboard();
      const data = res?.data?.data || {};

      setStats({
        total_orders: data?.stats?.total_orders ?? 0,
        pending_orders: data?.stats?.pending_orders ?? 0,
        delivered_orders: data?.stats?.delivered_orders ?? 0,
        active_cart: data?.stats?.active_cart ?? 0,
      });

      setRecentOrders(data?.recent_orders || []);
    } catch (err) {
      console.error("Dashboard API failed", err);
    } finally {
      setLoading(false);
    }
  }

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const statusStyle = (status) => {
    const s = status?.toLowerCase();
    if (s === "delivered") return { bg: "#DCFCE7", color: "#15803D" };
    if (s === "cancelled") return { bg: "#FEE2E2", color: "#DC2626" };
    if (s === "shipped") return { bg: "#E3F2FD", color: "#1565C0" };
    return { bg: "#FCE4EC", color: "#C2185B" };
  };

  const statCards = [
    {
      label: "Total Orders",
      value: stats.total_orders,
      icon: <Package size={18} />,
      bg: "#FCE4EC",
      color: "#C2185B",
    },
    {
      label: "In Transit",
      value: stats.pending_orders,
      icon: <Truck size={18} />,
      bg: "#E3F2FD",
      color: "#1565C0",
    },
    {
      label: "Delivered",
      value: stats.delivered_orders,
      icon: <CheckCircle size={18} />,
      bg: "#E8F5E9",
      color: "#2E7D32",
    },
    {
      label: "In Cart",
      value: stats.active_cart,
      icon: <ShoppingCart size={18} />,
      bg: "#FCE4EC",
      color: "#C2185B",
    },
  ];

  return (
    <DashboardLayout>
      <div className="space-y-5 mt-12 md:mt-0">
        {/* STATS */}
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-28 rounded-2xl bg-gray-100 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {statCards.map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-gray-100 shadow-sm px-4 py-5 flex flex-col items-center text-center"
              >
                <div
                  className="w-9 h-9 rounded-lg flex items-center justify-center mb-3"
                  style={{ background: item.bg, color: item.color }}
                >
                  {item.icon}
                </div>

                <h3 className="text-2xl font-bold text-gray-900">{item.value}</h3>
                <p className="text-xs text-gray-500 mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        )}

        {/* RECENT ORDERS */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
            <h4 className="font-semibold text-gray-800">Recent Orders</h4>

            <Link
              to="/dashboard/purchase-history"
              className="text-sm font-medium text-pink-600 hover:underline flex items-center gap-1"
            >
              View All <span aria-hidden>→</span>
            </Link>
          </div>

          {loading ? (
            <div className="p-5 space-y-3">
              {[1, 2].map((i) => (
                <div key={i} className="h-16 rounded-xl bg-gray-100 animate-pulse" />
              ))}
            </div>
          ) : recentOrders.length === 0 ? (
            <div className="px-5 py-8 text-sm text-gray-500">No orders found</div>
          ) : (
            <div className="divide-y divide-gray-100">
              {recentOrders.map((order) => {
                const status = statusStyle(order.order_status);
                const itemCount = order.items?.length || order.total_items || 0;
                const firstImage = order.items?.[0]?.image;

                return (
                  <div
                    key={order.id}
                    onClick={() =>
                      navigate(`/dashboard/purchase-history/order/${order.id}`)
                    }
                    className="flex items-center justify-between px-5 py-4 gap-4 cursor-pointer transition hover:bg-gray-50"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      <img
                        src={firstImage || "/placeholder.png"}
                        alt=""
                        className="w-12 h-12 rounded-lg object-cover border border-gray-100 flex-shrink-0"
                      />

                      <div className="min-w-0">
                        <p className="font-semibold text-sm text-gray-900 truncate">
                          #{order.order_number}
                        </p>
                        <p className="text-xs text-gray-500">
                          {formatDate(order.createdAt)} · {itemCount} item
                          {itemCount !== 1 ? "s" : ""}
                        </p>
                      </div>
                    </div>

                    <div className="text-right flex-shrink-0">
                      <p className="font-bold text-sm text-gray-900">
                        ₹{Number(order.grand_total).toLocaleString("en-IN")}
                      </p>

                      <span
                        className="inline-block mt-1 text-[11px] font-semibold px-2.5 py-1 rounded-full capitalize"
                        style={{ background: status.bg, color: status.color }}
                      >
                        {order.order_status}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}